import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "aria-label"];
const _hoisted_2 = { class: "conversation-accordion__header" };
import { ref, watch, nextTick, onMounted, onUnmounted, computed } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
// Components
import RecAccordion from "@/common/components/RecAccordion.vue";
import SummaryContent from "../components/SummaryContent.vue";
import SummaryControls from "@/common/components/SummaryControls.vue";
import AlertMessage from "@/common/components/AlertMessage.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SummaryBlock',
    props: {
        response: {},
        excerptable: { type: Boolean },
        wrapInAccordion: { type: Boolean, default: false },
        clipboardHeader: { default: "" },
        pending: { type: Boolean },
        guidelinesCustomized: { type: Boolean },
        userHasResponse: { type: Boolean },
        taskConfigUrl: { default: "" }
    },
    emits: ["regenerate"],
    setup(__props) {
        const props = __props;
        const { isModerator } = storeToRefs(useContext());
        const accordionTab = ref(0);
        const isDismissed = useLocalStorage("summary_guidelines_alert_dismissed", false);
        const showGuidelinesAlert = computed(() => isModerator.value && !props.guidelinesCustomized && !props.userHasResponse && !isDismissed.value);
        const onDismissAlert = () => {
            isDismissed.value = true;
        };
        let timeout = null;
        watch(accordionTab, async () => {
            await nextTick();
            if (timeout)
                clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.Ramius?.highlight?.drawMarkers?.();
            }, 500);
        });
        // Listen for excerpt mode changes from JSP
        const handleExcerptModeToggle = () => {
            if (props.wrapInAccordion) {
                accordionTab.value = 0;
            }
        };
        onMounted(() => {
            window.addEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        onUnmounted(() => {
            window.removeEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        const summaryText = computed(() => {
            if (!props.excerptable || !props.response.summary)
                return undefined;
            const rawContent = props.response.summary.rawContent || props.response.summary.content || "";
            return (props.clipboardHeader || "") + rawContent;
        });
        const preventRegenerateSummary = computed(() => !isModerator.value);
        const isSummaryOutdated = computed(() => !props.pending && !!props.response.summaryGuidelinesOutdated);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (showGuidelinesAlert.value && _ctx.wrapInAccordion)
                    ? (_openBlock(), _createBlock(AlertMessage, {
                        key: 0,
                        type: "warning",
                        dismissible: true,
                        onClose: onDismissAlert
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t("If this summary isn't what you expected, you can adjust the Summary Guidelines to change how AI summarizes conversations.")) + " ", 1),
                                _createElementVNode("a", {
                                    href: `${_ctx.taskConfigUrl}#summary-guidelines`,
                                    target: "_self",
                                    "aria-label": _ctx.$t('Improve Summary Guidelines')
                                }, _toDisplayString(_ctx.$t("Improve Guidelines")), 9, _hoisted_1)
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_ctx.wrapInAccordion)
                    ? (_openBlock(), _createBlock(RecAccordion, {
                        key: 1,
                        modelValue: accordionTab.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((accordionTab).value = $event)),
                        class: "conversation-accordion",
                        color: "ai-primary"
                    }, {
                        "tab-0-header": _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Conversation Summary")), 1),
                                (!_ctx.pending && _ctx.response.summary?.content)
                                    ? (_openBlock(), _createBlock(SummaryControls, {
                                        key: 0,
                                        "is-summary-outdated": isSummaryOutdated.value,
                                        "regenerate-tooltip": isSummaryOutdated.value ? _ctx.$t('Conversation Summary is outdated') : undefined,
                                        "prevent-regenerate": preventRegenerateSummary.value,
                                        "copy-text": summaryText.value,
                                        onRegenerate: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('regenerate')))
                                    }, null, 8, ["is-summary-outdated", "regenerate-tooltip", "prevent-regenerate", "copy-text"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        "tab-0-content": _withCtx(() => [
                            _createVNode(SummaryContent, {
                                excerptable: _ctx.excerptable,
                                response: _ctx.response
                            }, null, 8, ["excerptable", "response"])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(SummaryContent, {
                        key: 2,
                        excerptable: _ctx.excerptable,
                        response: _ctx.response,
                        "show-expand-toggle": ""
                    }, null, 8, ["excerptable", "response"]))
            ], 64));
        };
    }
});
